import type { FC, ReactNode } from 'react'

import Confetti, { BAND_CONFETTI } from '@/components/landing/confetti'
import Countdown from '@/components/landing/countdown'
import CalendarButtons from '@/components/landing/calendar-buttons'
import SectionHeading from '@/components/landing/section-heading'
import { invitation } from '@/constants/invitation'

const CountdownSection: FC = (): ReactNode => {
    const { date, time } = invitation

    return (
        <section
            id='compte-a-rebours'
            aria-labelledby='compte-a-rebours-titre'
            className='relative isolate overflow-hidden bg-foreground text-background'
        >
            <Confetti pieces={BAND_CONFETTI} className='-z-10 opacity-80' />

            <div className='mx-auto grid max-w-6xl items-center gap-12 px-5 py-20 sm:px-8 sm:py-24 lg:grid-cols-[1fr_auto] lg:gap-16'>
                <div>
                    <SectionHeading
                        id='compte-a-rebours-titre'
                        tone='inverted'
                        eyebrow="Le compte à rebours est lancé"
                        title={`Rendez-vous le ${date.full.toLowerCase()} à ${time.start}`}
                        description="Bloquez la date dès maintenant : la soirée s’ajoute à votre agenda en un clic."
                    />

                    <CalendarButtons tone='inverted' className='mt-8' />
                </div>

                <Countdown />
            </div>
        </section>
    )
}

export default CountdownSection
